import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LookMetricsInterface } from '../../models/dashboard/revenue/lookup-metrics';

interface IInitialState {
  lookupMetrics?: LookMetricsInterface;
}

const initialState: IInitialState = {
  lookupMetrics: undefined
};

const lookupMetricsSlice = createSlice({
  name: 'lookupMetricsSlice',
  initialState,
  reducers: {
    setLookupMetrics(state, action: PayloadAction<LookMetricsInterface>) {
      state.lookupMetrics = action.payload;
    },
  },
});

export const lookupMetricsActions = lookupMetricsSlice.actions;
export default lookupMetricsSlice.reducer;
